export default __webpack_public_path__ + "static/media/image08.228ed04d.jpg";